window.lang2 =
  {
  "general": {
    "accessibility": {
      "skip_to_content": "Skip to content",
      "close_modal": "Close (esc)",
      "close_menu": "Close Menu"
    },
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "breadcrumbs": {
      "home": "Home",
      "home_link_title": "Back to the home page"
    },
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "current_page": "Page {{ current }} of {{ total }}",
      "loading": "Loading...",
      "loadmore": "Load More"
    },
    "password_page": {
      "opening_soon": "Opening Soon",
      "login_form_heading": "Enter store using password",
      "login_form_password_label": "Password",
      "login_form_password_placeholder": "Your password",
      "login_form_submit": "Enter",
      "signup_form_email_label": "Email",
      "signup_form_success": "We will send you an email right before we open!",
      "admin_link_html": "Are you the store owner? <a href=\"\/admin\" class=\"text-link\">Log in here<\/a>",
      "password_link": "Enter using password",
      "powered_by_shopify_html": "This shop will be powered by {{ shopify }}"
    },
    "social": {
      "share_on_facebook": "Share",
      "share_on_twitter": "Tweet",
      "share_on_pinterest": "Pin it",
      "share_on_whatsapp": "Whatsapp",
      "share_on_email": "Email",
      "alt_text": {
        "share_on_facebook": "Share on Facebook",
        "share_on_twitter": "Tweet on Twitter",
        "share_on_pinterest": "Pin on Pinterest",
        "share_on_whatsapp": "Share on Whatsapp",
        "share_on_email": "Share by Email"
      }
    },
    "search": {
      "no_results_html": "Your search for \"{{ terms }}\" did not yield any results.",
      "results_with_count": {
        "one": "{{ count }} result for \"{{ terms }}\"",
        "other": "{{ count }} results for \"{{ terms }}\""
      },
      "title": "What are you looking for?",
      "placeholder": "Search for products, brands and more",
      "placeholder_blog": "Search for article",
      "tool_tip": "Search",
      "submit": "Submit",
      "close": "Close search",
      "all": "See all Results"
    },
    "newsletter_form": {
      "newsletter_email": "Join our mailing list",
      "email_placeholder": "Email address",
      "confirmation": "Thanks for subscribing",
      "mailChimp_confirmation": "Almost completed... just need to confirm your email address. To complete the process, please click the link in the email we just sent you.",
      "mailChimp_error": "Something went wrong, please try after some times.",
      "submit": "Subscribe",
      "note": "Your Information will never be shared with any third party.",
      "hide_message": "Don’t show this popup again"
    },
    "filters": {
      "show_more": "Show More",
      "show_less": "Show Less"
    }
  },
  "sections": {
    "slideshow": {
      "next_slide": "Next slide",
      "previous_slide": "Previous slide",
      "pause_slideshow": "Pause slideshow",
      "play_slideshow": "Play slideshow",
      "play_video": "Play video",
      "close_video": "Close video"
    },
    "map": {
      "get_directions": "Get directions",
      "address_error": "Error looking up that address",
      "address_no_results": "No results for that address",
      "address_query_limit_html": "You have exceeded the Google API usage limit. Consider upgrading to a <a href=\"https:\/\/developers.google.com\/maps\/premium\/usage-limits\">Premium Plan<\/a>.",
      "auth_error_html": "There was a problem authenticating your Google Maps account. Create and enable the <a href=\"https:\/\/developers.google.com\/maps\/documentation\/javascript\/get-api-key\">JavaScript API<\/a> and <a href=\"https:\/\/developers.google.com\/maps\/documentation\/geocoding\/get-api-key\">Geocoding API<\/a> permissions of your app."
    }
  },
  "blogs": {
    "article": {
      "view_all": "View all",
      "all_topics": "All topics",
      "by_author": "Posted by",
      "posted_in": "Posted in",
      "read_more": "Read more",
      "back_to_blog": "Back to {{ title }}"
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Name",
      "email": "Email",
      "message": "Message",
      "post": "Post comment",
      "moderated": "Please note, comments must be approved before they are published",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "comments_with_count": {
        "one": "{{ count }} comment",
        "other": "{{ count }} comments"
      }
    }
  },
  "cart": {
    "general": {
      "title": "Your cart",
      "note": "Special instructions for seller with your order",
      "remove": "Remove",
      "subtotal": "Subtotal",
      "savings": "You're saving",
      "shipping_at_checkout": "Shipping & taxes calculated at checkout",
      "update": "Update",
      "view_cart": "View Cart",
      "checkout": "Proceed to Checkout",
      "error": "Error",
      "added": "is added to your shopping cart.",
      "empty": "You don't have any items in your cart.",
      "cookies_required": "Enable cookies to use the shopping cart",
      "edit": "Edit",
      "cancel": "Cancel",
      "continue_shopping": "Continue shopping"
    },
    "label": {
      "product": "Product",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total"
    }
  },
  "collections": {
    "general": {
      "view_all": "Shop All Styles",
      "showing": "Showing:",
      "of": "of",
      "results": "Results",
      "no_matches": "Sorry, there are no products in this collection",
      "items_with_count": {
        "one": "{{ count }}",
        "other": "{{ count }}"
      }
    },
    "sorting": {
      "title": "Sort By",
      "featured": "Featured",
      "best_selling": "Best Selling",
      "az": "Alphabetically, A-Z",
      "za": "Alphabetically, Z-A",
      "price_ascending": "Price, low to high",
      "price_descending": "Price, high to low",
      "date_descending": "Date, new to old",
      "date_ascending": "Date, old to new"
    },
    "filters": {
      "title_tags": "Filter",
      "by": "SHOPPING BY:",
      "all_tags": "All products",
      "clear": "Clear All"
    }
  },
  "contact": {
    "form": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone Number",
      "message": "Message",
      "submit": "Send",
      "post_success": "Thanks for contacting us. We'll get back to you as soon as possible."
    }
  },
  "customer": {
    "account": {
      "title": "My Account",
      "details": "Account Details",
      "view_addresses": "View Addresses",
      "return": "Return to Account Details",
      "logout": "Logout"
    },
    "activate_account": {
      "title": "Activate Account",
      "subtext": "Create your password to activate your account.",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Activate Account",
      "cancel": "Decline Invitation"
    },
    "addresses": {
      "title": "Your Addresses",
      "default": "Default",
      "add_new": "Add a New Address",
      "edit_address": "Edit address",
      "first_name": "First Name",
      "last_name": "Last Name",
      "company": "Company",
      "address1": "Address1",
      "address2": "Address2",
      "city": "City",
      "country": "Country",
      "province": "Province",
      "zip": "Postal\/Zip Code",
      "phone": "Phone",
      "set_default": "Set as default address",
      "add": "Add Address",
      "update": "Update Address",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "delete_confirm": "Are you sure you wish to delete this address?"
    },
    "login": {
      "page_title": "My Account",
      "form_title": "LOGIN",
      "sub_text": "If you have an account with us, please log in.",
      "email": "Email",
      "password": "Password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign In",
      "guest_title": "Continue as a guest",
      "guest_continue": "Continue"
    },
    "register": {
      "page_title": "Create an Account",
      "form_title": "NEW CUSTOMER?",
      "sub_text": "Registering for this site allows you to access your order status and history. We’ll get a new account set up for you in no time. For this will only ask you for information necessary to make the purchase process faster and easier",
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "Email",
      "password": "Password",
      "accepts_marketing": "Subscribe to stay updated with new products and offers!",
      "submit": "Submit",
      "new": "New User?",
      "link": "Register Now"
    },
    "recover_password": {
      "title": "Reset your password",
      "email": "Email",
      "submit": "Submit",
      "cancel": "Cancel",
      "subtext": "We will send you an email to reset your password.",
      "success": "We've sent you an email with a link to update your password."
    },
    "reset_password": {
      "title": "Reset account password",
      "subtext": "Enter a new password for {{ email }}",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Reset Password"
    },
    "orders": {
      "title": "Order History",
      "order_number": "Order",
      "date": "Date",
      "payment_status": "Payment Status",
      "fulfillment_status": "Fulfillment Status",
      "total": "Total",
      "none": "You haven't placed any orders yet."
    },
    "order": {
      "title": "Order {{ name }}",
      "date": "Placed on {{ date }}",
      "cancelled": "Order Cancelled on {{ date }}",
      "cancelled_reason": "Reason: {{ reason }}",
      "billing_address": "Billing Address",
      "payment_status": "Payment Status",
      "shipping_address": "Shipping Address",
      "fulfillment_status": "Fulfillment Status",
      "discount": "Discount",
      "shipping": "Shipping",
      "tax": "Tax",
      "product": "Product",
      "sku": "SKU",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total",
      "fulfilled_at": "Fulfilled {{ date }}",
      "subtotal": "Subtotal"
    }
  },
  "homepage": {
    "onboarding": {
      "product_title": "Your product's name",
      "product_description": "This area is used to describe your product’s details. Tell customers about the look, feel, and style of your product. Add details on color, materials used, sizing, and where it was made.",
      "collection_title": "Select Collection",
      "blog_title": "Your post's title",
      "blog_excerpt": "Your store hasn’t published any blog posts yet. A blog can be used to talk about new product launches, tips, or other news you want to share with your customers. You can check out Shopify’s ecommerce blog for inspiration and advice for your own store and blog.",
      "blog_author": "Author name",
      "no_content": "This section doesn’t currently include any content."
    }
  },
  "layout": {
    "navigation": {
      "search": "Search",
      "toggle": "expand\/collapse",
      "expand": "expand",
      "collapse": "collapse"
    },
    "header_settingbox": {
      "icon_tooltip": "Settings"
    },
    "cart": {
      "title": "Cart",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Account",
      "log_out": "Log out",
      "log_in": "Log in",
      "create_account": "Create an account"
    },
    "footer": {
      "social_platform": "{{ name }} on {{ platform }}"
    }
  },
  "products": {
    "product": {
      "regular_price": "Regular price",
      "sold_out": "Sold out",
      "stock": "In Stock",
      "unavailable": "Unavailable",
      "available": "In Stock",
      "pre_order": "Pre-Order Now",
      "new": "New",
      "on_sale": "Sale",
      "you_save": "Save",
      "off": " off",
      "quick_view": "Quick View",
      "quantity": "Quantity",
      "quantity_message": "Hurry, Only {{items}} left!",
      "add_to_cart": "Add to cart",
      "quick_shop": "Quick Shop",
      "select_options": "Select Options",
      "add_to_wishlist": "Add to Wishlist",
      "view_wishlist": "View wishlist",
      "back_to_collection": "Back to {{ title }}",
      "availability": "",
      "sku": "SKU :",
      "type": "Type :",
      "vendor": "",
      "collection": "Collections :",
      "tags": "Tags :",
      "size_chart": "Size Chart",
      "shipping_link": "Delivery & Returns",
      "zoom": "Zoom Image",
      "video": "Watch Video",
      "360_view": "360 Product View",
      "prev": "Previous Product",
      "next": "Next Product",
      "check_availability": "Check Availability"
    },
    "wishlist": {
      "title": "Wishlist",
      "add_to": "Add to Wishlist",
      "view": "View Wishlist",
      "view_product": "View Product",
      "remove": "Remove From Wishlist",
      "available": "Available in Wishlist",
      "share": "Share my wish list via email",
      "wishlist-empty": "Products weren't added to the wishlist."
    },
    "enquiry": {
      "link": "Enquiry",
      "name": "Name",
      "email": "Email",
      "phone": "Phone Number",
      "message": "Message",
      "submit": "Send Message",
      "post_success": "Thanks for contacting us. We'll get back to you as soon as possible."
    },
    "quickview": {
      "Show_view_full_details_button": "View More Details"
    }
  },
  "gift_cards": {
    "issued": {
      "title_html": "Here's your {{ value }} gift card for {{ shop }}!",
      "subtext": "Your gift card",
      "disabled": "Disabled",
      "expired": "Expired on {{ expiry }}",
      "active": "Expires on {{ expiry }}",
      "redeem_html": "Use this code at checkout to redeem your {{ value }} gift card",
      "shop_link": "Start shopping",
      "print": "Print",
      "remaining_html": "{{ balance }} left",
      "add_to_apple_wallet": "Add to Apple Wallet"
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y",
    "days": "Days",
    "hours": "Hrs",
    "minuts": "Min",
    "seconds": "Sec",
    "short_names": {
      "days": "Days",
      "hours": "Hrs",
      "minuts": "Min",
      "seconds": "Sec"
    },
    "day_names": {
      "sunday": "Sunday",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday"
    },
    "months": {
      "jan": "January",
      "feb": "February",
      "mar": "March",
      "apr": "April",
      "may": "May",
      "jun": "June",
      "jul": "July",
      "aug": "August",
      "sep": "September",
      "oct": "October",
      "nov": "November",
      "dec": "December"
    }
  }
}